module.exports = __webpack_public_path__ + "img/activity-walking.50bf13af.jpg";